/* =============================================================================
   Pressed Objects — custom.js
   ============================================================================= */

/* --- Lenis smooth scroll --- */
const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  smoothWheel: true,
});
window.lenis = lenis;

/* Prevent Lenis from intercepting scroll inside the product zoom modal */
document.addEventListener('DOMContentLoaded', function () {
  var modalContent = document.querySelector('.product-media-modal__content');
  if (modalContent) modalContent.setAttribute('data-lenis-prevent', '');
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

/* --- Hero wordmark scale + logo reveal + nav hide/show (scroll-driven) --- */
(function () {
  var nav = document.querySelector('.po-nav-wrapper');
  var hero = document.getElementById('po-hero');
  var wordmark = hero ? hero.querySelector('.po-hero__word') : null;
  var isMobile = window.innerWidth < 800;
  if (!nav) return;

  /* No hero, or mobile = show logo immediately, skip the shrink-into-logo animation */
  if (!hero || isMobile) {
    nav.classList.add('logo-visible');
    var logo = nav.querySelector('.po-nav__logo');
    if (logo) logo.style.transform = 'translateY(0) scale(1)';
  }

  var ticking = false;
  var wordmarkH = wordmark ? wordmark.offsetHeight : 200;
  var sectionHeader = nav.closest('.section-header');
  var prevY = 0;
  var goingDown = false;
  var turnPoint = 0;
  var navHidden = false;
  var heroBottom = 0;
  function calcHeroBottom() {
    if (!hero) return 0;
    var rect = hero.getBoundingClientRect();
    heroBottom = (window.pageYOffset || document.documentElement.scrollTop) + rect.bottom - nav.offsetHeight;
  }
  calcHeroBottom();
  window.addEventListener('resize', calcHeroBottom);

  function update() {
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;

    /* --- Hero wordmark scale + logo reveal (skipped on mobile — logo is set once, permanently visible) --- */
    if (wordmark && hero && !isMobile) {
      var progress = Math.min(1, Math.max(0, scrollY / (wordmarkH + 48)));
      var scale = 1 - (progress * 0.5);
      wordmark.style.transform = 'scale(' + Math.max(0.5, scale) + ')';

      var logoStart = wordmarkH * 0.3;
      var logoEnd = wordmarkH * 0.9;
      var logo = nav.querySelector('.po-nav__logo');

      if (scrollY > logoStart && logo) {
        nav.classList.add('logo-visible');
        var logoProgress = Math.min(1, (scrollY - logoStart) / (logoEnd - logoStart));
        var logoScale = 0.5 + (logoProgress * 0.5);
        var logoY = 48 - (logoProgress * 48);
        logo.style.transform = 'translateY(' + logoY + 'px) scale(' + logoScale + ')';
      } else if (logo) {
        nav.classList.remove('logo-visible');
        logo.style.transform = 'translateY(48px) scale(0.5)';
      }
    }

    /* --- Nav hide/show (targets .section-header, the actual sticky wrapper) --- */
    if (!sectionHeader) { ticking = false; return; }

    var navH = sectionHeader.offsetHeight;
    var nowDown = scrollY > prevY;
    var nowUp = scrollY < prevY;

    if (nowDown && !goingDown) { turnPoint = scrollY; goingDown = true; }
    if (nowUp && goingDown) { turnPoint = scrollY; goingDown = false; }

    prevY = scrollY;

    if (scrollY <= heroBottom) {
      /* In hero zone — nav fully visible, no transition */
      sectionHeader.classList.remove('nav-showing');
      sectionHeader.style.transform = '';
      navHidden = false;
    } else if (goingDown) {
      /* Scrolling down past hero — push nav up tied to scroll */
      sectionHeader.classList.remove('nav-showing');
      var push = Math.min(navH, scrollY - heroBottom);
      sectionHeader.style.transform = 'translateY(' + (-push) + 'px)';
      navHidden = push >= navH;
    } else if (!goingDown && turnPoint - scrollY > 20 && navHidden) {
      /* Scrolling up — animate back in */
      sectionHeader.classList.add('nav-showing');
      sectionHeader.style.transform = 'translateY(0)';
      navHidden = false;
    }

    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
})();

/* --- WIP Carousel: auto-scroll --- */
document.addEventListener('DOMContentLoaded', function () {
  var carousel = document.getElementById('po-wip-carousel');
  if (!carousel) return;

  var allCards = carousel.querySelectorAll('.po-wip__card');
  var total = allCards.length;
  var blockCount = Math.round(total / 3);
  if (blockCount === 0) return;

  var offset = 0;
  var speedPerMs = 0.05; /* px/ms, frame-rate independent */
  var oneThird = 0;
  var lastTime = null;

  function measure() {
    oneThird = blockCount * allCards[0].offsetWidth;
  }

  function updatePosition() {
    carousel.style.transform = 'translate3d(' + offset.toFixed(2) + 'px, 0, 0)';
  }

  function loop(time) {
    if (lastTime === null) lastTime = time;
    var delta = time - lastTime;
    lastTime = time;

    if (!isDragging) {
      offset -= speedPerMs * delta;
      if (offset <= -oneThird * 2) offset += oneThird;
      updatePosition();
    }
    requestAnimationFrame(loop);
  }

  measure();
  window.addEventListener('resize', measure);

  /* Start offset at -oneThird so we're in the middle set */
  offset = -oneThird;
  requestAnimationFrame(loop);

  /* --- Drag to scroll --- */
  var isDragging = false;
  var dragMoved = false;
  var dragStartX = 0;
  var dragStartOffset = 0;
  var DRAG_THRESHOLD = 6;

  function onPointerDown(e) {
    isDragging = true;
    dragMoved = false;
    dragStartX = e.clientX;
    dragStartOffset = offset;
  }

  function onPointerMove(e) {
    if (!isDragging) return;
    var delta = e.clientX - dragStartX;
    if (!dragMoved && Math.abs(delta) > DRAG_THRESHOLD) {
      dragMoved = true;
      carousel.classList.add('is-dragging');
      /* capture lazily, only once a real drag is confirmed, so a plain
         click/tap never touches pointer capture and can still navigate */
      carousel.setPointerCapture(e.pointerId);
    }
    if (!dragMoved) return;
    offset = dragStartOffset + delta;
    while (offset <= -oneThird * 2) offset += oneThird;
    while (offset >= 0) offset -= oneThird;
    updatePosition();
  }

  function endDrag(e) {
    if (!isDragging) return;
    isDragging = false;
    carousel.classList.remove('is-dragging');
    if (e && e.pointerId != null && carousel.hasPointerCapture && carousel.hasPointerCapture(e.pointerId)) {
      carousel.releasePointerCapture(e.pointerId);
    }
    /* resume auto-scroll cleanly from current position */
    lastTime = null;
  }

  carousel.addEventListener('pointerdown', onPointerDown);
  window.addEventListener('pointermove', onPointerMove);
  window.addEventListener('pointerup', endDrag);
  window.addEventListener('pointercancel', endDrag);
  window.addEventListener('blur', endDrag);

  /* stop the browser's native image/link drag-ghost from hijacking the gesture */
  carousel.addEventListener('dragstart', function (e) {
    e.preventDefault();
  });

  /* suppress the click-through navigation when a drag actually moved */
  carousel.addEventListener('click', function (e) {
    if (dragMoved) {
      e.preventDefault();
      e.stopPropagation();
      dragMoved = false;
    }
  }, true);

});

/* --- WIP: Auto-fetch OG thumbnails from Substack --- */
document.addEventListener('DOMContentLoaded', function () {
  var byUrl = {};
  document.querySelectorAll('.po-wip__og-placeholder[data-og-url]').forEach(function (el) {
    var url = el.getAttribute('data-og-url');
    if (!url) return;
    if (!byUrl[url]) byUrl[url] = [];
    byUrl[url].push(el);
  });
  Object.keys(byUrl).forEach(function (url) {
    fetch('https://api.microlink.io/?url=' + encodeURIComponent(url))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var imgUrl = data && data.data && data.data.image && data.data.image.url;
        if (!imgUrl) return;
        byUrl[url].forEach(function (el) {
          var cardImage = el.closest('.po-wip__card-image');
          if (cardImage) cardImage.style.padding = '0';
          var img = document.createElement('img');
          img.className = 'po-wip__card-img';
          img.src = imgUrl;
          img.alt = '';
          el.replaceWith(img);
        });
      })
      .catch(function () {});
  });
});

/* --- Product page: mobile gallery \u2014 transform-based slider.
   Not using native scroll/scroll-snap: Dawn's slider-component carries
   legacy scroll-padding/peek behavior that kept desyncing snap points
   from the actual slide width. Direct transform sidesteps all of it. --- */
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth >= 900) return;
  var mediaWrapper = document.querySelector('product-info .product__media-wrapper');
  if (!mediaWrapper) return;

  var list = mediaWrapper.querySelector('.product__media-list');
  var slides = list ? Array.prototype.slice.call(list.querySelectorAll('.product__media-item')) : [];
  if (slides.length < 2) return;

  /* Native loading="lazy" never fires for these — transform doesn't move
     them through the browser's actual scroll position, so the lazy-load
     intersection check never triggers. Force them to load up front. */
  slides.forEach(function (slide) {
    slide.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  });

  /* All slides sit side-by-side in one row so the transform can slide
     between them — that means the row's natural height is the TALLEST
     slide, leaving dead space below any shorter one. Sync the wrapper's
     height to whichever slide is actually active. No transition on
     height: animating it forces a layout recalculation every frame,
     which is what was making the swipe feel choppy. Snap instantly;
     only the transform (GPU-composited) animates smoothly. */
  list.style.transition = 'transform 0.3s ease-out';

  var current = 0;

  function syncHeight() {
    mediaWrapper.style.height = slides[current].offsetHeight + 'px';
  }

  var dots = [];

  function goTo(index) {
    current = Math.max(0, Math.min(slides.length - 1, index));
    list.style.transform = 'translateX(-' + (current * 100) + '%)';
    syncHeight();
    dots.forEach(function (dot, i) {
      dot.classList.toggle('po-mobile-gallery-dots__dot--active', i === current);
    });
  }

  /* Re-sync whenever the active slide's own size actually changes, for any
     reason — e.g. opening/closing the zoom modal toggles a scroll lock on
     body that can shift layout after goTo() already ran. */
  var heightObserver = new ResizeObserver(syncHeight);
  slides.forEach(function (slide) { heightObserver.observe(slide); });

  var nav = document.createElement('div');
  nav.className = 'po-mobile-gallery-dots';
  slides.forEach(function (slide, i) {
    var dot = document.createElement('button');
    dot.className = 'po-mobile-gallery-dots__dot';
    dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
    dot.addEventListener('click', function () { goTo(i); });
    nav.appendChild(dot);
    dots.push(dot);
  });
  mediaWrapper.appendChild(nav);

  /* Swipe */
  var startX = null;
  list.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
  }, { passive: true });
  list.addEventListener('touchend', function (e) {
    if (startX === null) return;
    var dx = e.changedTouches[0].clientX - startX;
    startX = null;
    if (dx < -40) goTo(current + 1);
    else if (dx > 40) goTo(current - 1);
  });

  goTo(0);
});

/* --- Product page: pin buy button + installment at bottom of sticky panel --- */
document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('product-info .product__info-wrapper');
  var container = document.querySelector('product-info .product__info-container');
  var form = document.querySelector('product-info product-form');
  if (!wrapper || !container || !form) return;

  /* Move product-form out of the scrollable container to be a direct child
     of the sticky wrapper — this pins it to the bottom outside the scroll */
  wrapper.appendChild(form);
});

/* --- Cart count update (subscribe to Dawn's pub-sub) --- */
(function () {
  var countEl = document.getElementById('po-cart-count');
  if (!countEl) return;

  subscribe('cart-update', function (event) {
    var cartData = event && event.cartData;
    if (!cartData) return;

    /* Try to extract count from the rendered cart-icon-bubble section HTML */
    if (cartData.sections && cartData.sections['cart-icon-bubble']) {
      var doc = new DOMParser().parseFromString(cartData.sections['cart-icon-bubble'], 'text/html');
      var bubble = doc.querySelector('#po-cart-count');
      countEl.textContent = bubble ? bubble.textContent.trim() : '0';
      return;
    }

    /* Fallback: direct item_count if available */
    if (typeof cartData.item_count === 'number') {
      countEl.textContent = cartData.item_count;
      return;
    }

    /* Last resort: fetch /cart.js */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { countEl.textContent = cart.item_count; })
      .catch(function () {});
  });
})();

/* --- Product page: description tabs (dynamic — any [LABEL] marker) --- */
document.addEventListener('DOMContentLoaded', function () {
  var tabs = document.querySelector('.po-pdp-tabs');
  if (!tabs) return;

  var raw = tabs.querySelector('.po-pdp-tabs__raw');
  if (!raw) return;

  var nav = tabs.querySelector('.po-pdp-tabs__nav');
  var panelsEl = tabs.querySelector('.po-pdp-tabs__panels');
  var html = raw.innerHTML;

  /* Split on any [LABEL] marker. Shopify rich text wraps lines in <p> tags,
     so match <p>[LABEL]</p> or bare [LABEL]. Capture the label text. */
  var markerRe = /<p[^>]*>\s*\[([^\]]+)\]\s*<\/p>|\[([^\]]+)\]/i;
  var sections = [{ label: 'Description', content: '' }];
  var remaining = html;

  while (true) {
    var m = markerRe.exec(remaining);
    if (!m) {
      sections[sections.length - 1].content = remaining;
      break;
    }
    sections[sections.length - 1].content = remaining.slice(0, m.index);
    var labelRaw = (m[1] || m[2]).trim();
    var label = labelRaw.charAt(0).toUpperCase() + labelRaw.slice(1).toLowerCase();
    sections.push({ label: label, content: '' });
    remaining = remaining.slice(m.index + m[0].length);
  }

  /* Build tab buttons and panels dynamically */
  sections.forEach(function (section, i) {
    var slug = section.label.toLowerCase().replace(/\s+/g, '-');
    var isEmpty = !section.content.trim();

    var btn = document.createElement('button');
    btn.className = 'po-pdp-tabs__btn' + (i === 0 ? ' po-pdp-tabs__btn--active' : '');
    btn.setAttribute('data-tab', slug);
    btn.textContent = section.label;
    if (isEmpty) btn.style.display = 'none';
    nav.appendChild(btn);

    var panel = document.createElement('div');
    panel.className = 'po-pdp-tabs__panel' + (i === 0 ? ' po-pdp-tabs__panel--active' : '');
    panel.setAttribute('data-panel', slug);
    panel.innerHTML = section.content.trim();
    panelsEl.appendChild(panel);
  });

  /* Tab switching */
  nav.addEventListener('click', function (e) {
    var btn = e.target.closest('.po-pdp-tabs__btn');
    if (!btn) return;
    nav.querySelectorAll('.po-pdp-tabs__btn').forEach(function (b) { b.classList.remove('po-pdp-tabs__btn--active'); });
    panelsEl.querySelectorAll('.po-pdp-tabs__panel').forEach(function (p) { p.classList.remove('po-pdp-tabs__panel--active'); });
    btn.classList.add('po-pdp-tabs__btn--active');
    var target = panelsEl.querySelector('[data-panel="' + btn.getAttribute('data-tab') + '"]');
    if (target) target.classList.add('po-pdp-tabs__panel--active');
  });
});
